const AWS = require("aws-sdk");
const { getConfig } = require("../../config");
const { getTemporarySessionCredentials } = require("./session");
AWS.config.update({ region: getConfig("AWS_REGION") });

/**
 * Function to generate/use existing credentials to create SQS client
 * @returns SQS object from AWS SDK
 */
const getSQSClient = async (IAM_ASSUME_ROLE) => {
  const creds = await getTemporarySessionCredentials(IAM_ASSUME_ROLE);
  const sqsClient = new AWS.SQS(creds);
  return sqsClient;
};

/**
 * Function to generate/use existing credentials to create S3 client
 * @returns S3 object from AWS SDK
 */
const getS3Client = async () => {
  const creds = await getTemporarySessionCredentials();
  return new AWS.S3(creds);
};

module.exports = { getSQSClient, getS3Client };
